/**
 * 救援司机单详情页面
 * 创建时间：2017-09-06
 * 创建人：baixx
 */
<template>
	<div class="float-e-margins ibox-content ibox_main tabBox" :id="'rescuedriversorder-edit' + dataInfo.rescueOrderId" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="grey_box">
			<div class="form-horizontal">
				<div class="form-horizontal">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">救援基本信息</label>
					</div>
				</div>
				<div class="form-horizontal ibox-content">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援单号</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="dataInfo.rescueOrderId" readonly>
						</div>
						<label class="col-sm-1 control-label">时间类型</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="dataInfo.dateType" readonly>
						</div>
						<label class="col-sm-1 control-label">请求时间</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="dataInfo.requestTime" readonly>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">救援状态</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="dataInfo.rescueStageTxt" readonly>
						</div>
						<label class="col-sm-1 control-label">救援类型</label>
						<div class="col-sm-3">
							<div class="col-sm-3 control-label" >
								<input type="radio" value="1" v-model="dataInfo.rescueType" disabled/>
								<span>拖车</span>
							</div>
							<div class="col-sm-3 control-label">
								<input type="radio" value="2" v-model="dataInfo.rescueType" disabled/>
								<span>搭电</span>
							</div>
							<div class="col-sm-3 control-label">
								<input type="radio" value="3" v-model="dataInfo.rescueType" disabled/>
								<span>路修</span>
							</div>
							<div class="col-sm-3 control-label">
								<input type="radio" value="4" v-model="dataInfo.rescueType" disabled/>
								<span>地库拖车</span>
							</div>
						</div>
					</div>
			    </div>
			</div>    
			<div class="form-horizontal mt5px">
				<div class="form-group text-left">
					<label class="col-sm-6  control-label t_left">被救援人信息</label>
				</div>
			</div>
			<div class="form-horizontal ibox-content mt20px">
				<br /> 
				<div class="form-group">
					<label class="col-sm-1 control-label">车牌号</label>
					<div class="col-sm-3" >
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedPlateNumber" readonly>
					</div>
					<label class="col-sm-1 control-label">车型</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedModel" readonly>
					</div>
					<label class="col-sm-1 control-label">颜色</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedColor" readonly>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">车主姓名</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedName" readonly>
					</div>
					<label class="col-sm-1 control-label">手机号</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedPhone" readonly>
					</div> 
				</div>
				
				<div class="form-group">
					<label class="col-sm-1 control-label">救援地址</label>
					<div class="col-sm-5">
						<input type="text" class="form-control" v-model.trim="dataInfo.rescuedAddress" readonly/>
					</div>
					<label class="col-sm-1 control-label">目的地址</label>
					<div class="col-sm-5">
						<input type="text" class="form-control" v-model="dataInfo.destAddress" readonly/>
					</div> 
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">备注</label>
					<div class="col-sm-11">
						<textarea type="text" class="form-control" v-model.trim="dataInfo.rescuedMemo" readonly/></textarea>
					</div>
				</div>
			</div>	
			<div class="form-horizontal mt5px">
				<div class="form-group text-left">
					<label class="col-sm-6  control-label t_left">救援信息</label>
				</div>
			</div>
			<div class="form-horizontal ibox-content mt20px">
				<br />
				<div class="form-group">
					<label class="col-sm-1 control-label">车牌号</label>
					<div class="col-sm-3">
						<input type="text" class="form-control"  v-model.trim="dataInfo.plateNumber" readonly/>
					</div>
					<label class="col-sm-1 control-label">派单时间</label>
					<div class="col-sm-3">
						<input type="text" class="form-control"  v-model.trim="dataInfo.dispatchTime" readonly/>
					</div>
					<label class="col-sm-1 control-label">救援公司</label>
					<div class="col-sm-3">
						<input type="text" class="form-control"  v-model="dataInfo.customerName" readonly>
					</div> 
				</div>	
				<div class="form-group">
					<label class="col-sm-1 control-label">司机</label>
					<div class="col-sm-3">
						<input type="text" class="form-control"  v-model="dataInfo.driverName" readonly>
					</div>
					<label class="col-sm-1 control-label">司机电话</label>
					<div class="col-sm-3">
						<input type="text" class="form-control"  v-model="dataInfo.driverPhone" readonly>
					</div>
				</div>
				<rescue-order-pics
						v-if="dataInfo.photos"
						:picUrl="picUrl"
						:picUrl2="picUrl2"
						:id="'#rescuedriversorder-edit' + dataInfo.rescueOrderId"
						:photos="dataInfo.photos"
						>
					</rescue-order-pics>
				<!-- <div class="form-group">
					<label class="col-sm-1 control-label">现场照片</label>
					<div class="col-sm-11"> 
						<div class="col-sm-1 live_photo" v-for="locale in dataInfo.photos"  @click.prevent="getMaxPic($event,locale)">
							<a v-if="locale.photoStatus==2" class="thumbnail">
								<div :style="{backgroundImage:'url('+ picUrl2 + locale.logourl + ')',backgroundSize:'cover',height:'100px',width:'100px'}"></div>
								<p>{{getPhotoStatus(locale.photoStatus)}}</p>
							</a>
							<a v-else class="thumbnail">
								<div :style="{backgroundImage:'url('+ picUrl + locale.logourl + ')',backgroundSize:'cover',height:'100px',width:'100px'}" ></div>
								<p>{{getPhotoStatus(locale.photoStatus)}}</p>
							</a>
						</div> 
					</div> 
				</div> -->
				<!--<div class="form-group">
					<label class="col-sm-1 control-label">现场照片</label>
				
					<div class="col-sm-11">
						<div class="col-sm-2" v-for="locale in photoArr" style="height:200px; width:200px; margin-left:5px; margin-top:5px;">
                        	<img :src=locale  alt="" />
						</div> 
					</div>
				</div>-->
			</div>
			<div class="form-horizontal mt5px">
				<div class="form-group text-left">
					<label class="col-sm-6  control-label t_left">救援总结</label>
				</div>
			</div>
			<div class="form-horizontal  ibox-content mt20px">
				<div class="form-group">
					<label class="col-sm-1 control-label">救援总里程</label>
					<div class="col-sm-2 control-label t_left">
						{{dataInfo.totalMileage==0?dataInfo.totalMileage + 'km':dataInfo.totalMileage/1000 + 'km'}}
					</div>
					<label class="col-sm-1 control-label">其中至现场里程</label>
					<div class="col-sm-2 control-label t_left">
						{{dataInfo.sceneMileage==0?dataInfo.sceneMileage + 'km':dataInfo.sceneMileage/1000 + 'km'}} 
					</div>
					<label class="col-sm-1 control-label">至目的地里程</label>
					<div class="col-sm-2 control-label t_left">
						{{dataInfo.descMileage==0?dataInfo.descMileage + 'km':dataInfo.descMileage/1000 + 'km'}} 
					</div>
					<label class="col-sm-1 control-label">救援结算费用</label>
					<div class="col-sm-2 control-label t_left">
						{{dataInfo.closingCost/100 + '元'}}
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">救援总耗时</label>
					<div class="col-sm-2 control-label t_left">
						{{conversion(dataInfo.totalElapsedTime)}}
					</div>
					<label class="col-sm-1 control-label">其中至现场耗时</label>
					<div class="col-sm-2 control-label t_left">
						{{conversion(dataInfo.sceneElapsedTime)}}
					</div>
					<label class="col-sm-1 control-label">至目的地耗时</label>
					<div class="col-sm-2 control-label t_left">
						{{conversion(dataInfo.descElapsedTime)}}
					</div> 
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">司机自接单</label>
					<div class="col-sm-11 control-label t_left"><span class="gary">{{dataInfo.connectionStartTimeNote}}</span>&nbsp;&nbsp;<label>后与客户进行了联系</label></div>
				</div>
				<div v-if="levv==2 && dataInfo.evaluateStatus!=0" class="form-group">
					<label class="col-sm-1 control-label">客户评价</label>
					<div class="col-sm-11">
						<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==1}">好评</span>
						<span class="col-sm-1"></span>
						<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==2}">中评</span>
						<span class="col-sm-1"></span>
						<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==3}">差评</span>
					</div> 
				</div>
				<div v-if="levv==2 && dataInfo.evaluateStatus!=0" class="form-group">
					<label class="col-sm-1 control-label">评价详情</label>
					<div class="col-sm-11">
						<textarea type="text" class="form-control" v-model.trim="dataInfo.evaluateRemark" maxlength="254" readonly="readonly"></textarea>
					</div>
				</div>
			</div>
			</br>
			<div class="form-horizontal">
				<div class="form-group">
					<div class="col-sm-12 text-center">
						<a  class="btn btn-primary white" @click="closeSub">关闭</a>
					</div>
				</div>
			</div>
		</div>
		<!--提示弹框开始-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" @cancel="closeMsgTip">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</tab-modal>
		<!--SubPage组件弹框结束-->
	</div>	
</template> 
<script>
	import TabModal from 'components/common/TabModal'
    import { SAVE_ENSURE,OPERATE_EXCEPTION } from 'static/message'
    import { required,numeric,maxLength } from 'vuelidate/lib/validators'
    import {deepCopy,getDictionaryFromArray} from 'util/util' 
    import classlist from 'util/classlist'
    import Mock from 'mockjs'
	import RescueOrderPics from 'components/common/RescueOrderPics'
	export default{
		name: "PageRescueDriveOrderDetail",
		components: {
			TabModal,
			RescueOrderPics
		}, 
		data() {
			return {
				loadingstatus:false,
				tipContent:'',
				dataInfo:{},
				scrollTop: '',
				id:'',
				driverId:'',
				driveUrl:'',
				from:'',
				picUrl:process.env.PIC_PATH,
				picUrl2:process.env.PIC_PATH2,
				photoArr:[],
			};
		},
		created(){
			this.from = this.$route.query.from
			if(this.from ==0){
				this.id = this.$route.query.id 
			    this.driverId = this.$route.query.driverId 
				this.driveUrl = process.env.API_INSURANCE_ROOT + '/rescue-api/driver/'+this.driverId+'/history/detail/' + this.id
			}else{
				this.id = this.$route.query.id 
			    this.vehicleId = this.$route.query.vehicleId 
				this.driveUrl = process.env.API_INSURANCE_ROOT + '/rescue-api/vehicles/'+this.vehicleId+'/history/detail/' + this.id
			}
		},
		computed:{
			levv(){
				return this.$store.state.user.levv
			}
		},
		beforeMount() {
			this.initOrderForm()
		},
		methods: {
			initOrderForm(){//详情时，获取form数据
				this.$http.get(this.driveUrl)
				.then( res => { 
					if(res.body.success){
						this.dataInfo = res.body.data
						if(this.dataInfo.dateType==0){
							this.dataInfo.dateType = '实时(默认)'
						}if(this.dataInfo.dateType==1){
							this.dataInfo.dateType = '预约'
						}
						if(this.dataInfo.isUnderground==1 && this.dataInfo.rescueType==1){
							this.dataInfo.rescueType = 4
						}
						this.dataInfo.rescueStageTxt = res.body.data.rescueStatusTxt+'-'+res.body.data.rescueStageTxt
						//for(var i = 0; i < this.dataInfo.photos.length; i++) {
						//	this.photoArr.push(this.picUrl+this.dataInfo.photos[i].logourl)
						//}
					}else{
						this.openMsgTip("请求异常")
					}
				}, res => {
					this.openMsgTip(res.body.message)
				}).catch( res => {
					this.openMsgTip(OPERATE_EXCEPTION)
				})
			},
			//时间转换
			conversion(value){
				var theTime = parseInt(value);// 秒 
				var theTime1 = 0;// 分 
				var theTime2 = 0;// 小时 
				// alert(theTime); 
				if(theTime >= 60) { 
					theTime1 = parseInt(theTime/60); 
					theTime = parseInt(theTime%60); 
				// alert(theTime1+"-"+theTime); 
				  if(theTime1 >= 60) { 
					theTime2 = parseInt(theTime1/60); 
					theTime1 = parseInt(theTime1%60); 
				  } 
				} 
				var result = ""+parseInt(theTime)+"秒"; 
				if(theTime1 > 0) { 
				    result = ""+parseInt(theTime1)+"分"+result; 
				} 
				if(theTime2 > 0) { 
				    result = ""+parseInt(theTime2)+"小时"+result; 
				} 
				//result=result.replace(/0秒/g,'');
				return result; 
			},
			// getPhotoStatus(val){
			// 	if(val===0){
			// 		return '到达现场上传'
			// 	}else if(val===1){
			// 		return '作业救援上传'
			// 	}else{
			// 		return '视频设备抓拍'
			// 	}
			// },
			closeSub(){
				for(var i = 0; i < this.$store.state.home.tabList.length; i++) {
					 if(this.$store.state.home.tabList[i].id == "PageRescueDriveOrderDetail"){
					 	this.$store.dispatch('closeTab',i);
                        this.$router.push(this.$store.state.home.path);
					}
				}
			},
			// getMaxPic(e,item){
			// 	let idSelector = '#rescuedriversorder-edit' + this.dataInfo.rescueOrderId
			// 	this.showDetailPic(idSelector,e,item,classlist) 
			// },
			closeMsgTip() {
				this.$refs.modalMsg.close();	
				classlist.toggleScroll('open','#rescuedriversorder-edit' + this.dataInfo.rescueOrderId,this);
			}, 
			//提示弹框相关-------------
			openMsgTip(message) { 
				this.tipContent = message
				this.$refs.modalMsg.open();
				classlist.toggleScroll('close','#rescuedriversorder-edit' + this.dataInfo.rescueOrderId,this);
			}

		}
	}
	
</script>
<style scoped>
	ul li {
		float: left;
		padding: 5px 10px;
		list-style: none;
	}
	
	ul {
		border: 1px solid #ccc;
	}
	
	li {
		border-right: 1px solid #ccc;
	}
	
	li.active {
		background-color: #000;
	}
	.clientReview{
		text-align: center!important;
		background-color:#D4D4D4; 
		
	}
	.clientReview.active{
		background-color:#309c34;
		color:#fff;
	}
	.red_bg{
		background-color:rgba(201,9,1,0.3);
	}
	.green_bg{
		background-color:#46AC89;
	}
	.yellow_bg{
		background-color:#FDF7DC;
	}
</style>


// WEBPACK FOOTER //
// PageRescueDriveOrderDetail.vue?38656eae